<template>
  <div id="userLogin" class="login_content"
    :class="{ 'login_content_c': schoolShowFlag, 'login_content_teacher': showTeacherBackground == 1, 'login_content_student': showTeacherBackground == 2 }">
    <div v-if="loginSuc" :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'">
      <div class="login_success">
        <img src="../../src/images/login/success.svg" alt />
        <div class="suc_mess">登录成功</div>
        <!-- <div class="to_jump">正在跳转{{sucTo}}s</div> -->
      </div>
    </div>
    <div v-if="!showForget && !loginSuc && !elseLoginWay && !qrLoginWay"
      :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'">
      <div v-if="nextPage == 1" class="login_index">
        <!-- 默认登录页 -->
        <div class="mess_pop">
          <div v-if="ifNotied" class="notied fadein" v-text="ifNotiedText"></div>
        </div>
        <div class="login_box">
          <div class="login_title"></div>
          <div class="login_message">
            <!-- <div v-if="showErrCode" class="code_inp"> -->
            <div v-if="showImgErrCode && tabActive == 2" class="code_inp">
              <div class="mark"></div>
              <!-- <div v-if="true" class="code_inp"> -->
              <dragView @offbtn="offDarg" />
              <!-- 三次密码错误 -->
              <img id="codePic" src alt title="点击刷新" @click="getCodeErr()" />
              <span class="code_btn" title="获取验证码" @click="getCodeErr()">获取验证码</span>
              <input name="code" type="text" maxlength="50" id="errverCode" placeholder="请输入验证码"
                autocomplete="new-password" v-model.trim="errverCode" @focus="codeFocus" @blur="codeBlur" />
              <div v-if="showError" class="err_mess">
                <p id="errMessP" v-text="errPop2"></p>
              </div>
            </div>
            <div class="login_input">
              <div class="user_inp">
                <!-- <p v-if="tabActive == 0 && (userName.length > 0 || showSearBtn)" class="inquire_abb cursor_p">
                  <a class="use_a"
                    :href="origin + '/iplat/fifMobile/fif_login/webpage/web_h5_search/index.html'">查询学校简称</a>
                </p> -->
                <input v-if="tabActive == 2" type="text" name="tel1" style="
                    position: absolute;
                    font-size: 0;
                    width: 1px;
                    height: 1px;
                    padding: 0;
                    border-bottom: 0 !important;
                  " />
                  <!-- <el-form v-if="tabActive == 0" ref="form" :model="inputData" label-width="80px" autocomplete="on"> -->
                    
                <el-input v-if="tabActive == 0" ref="saveTagInput" name="user" type="text" maxlength="50" autocomplete="on"
                  v-model="userName" :class="{ 'error_input': errPop1, 'initialization_input': initialization }"
                  placeholder="请输入学校简称+学工号" @keyup.enter.native="subMit()" @focus="userFocus" @blur="userBlur" />
                  <!-- </el-form> -->
                <el-form v-else :model="inputData" ref="knowledgeForm" inline>
                  <el-input maxlength="50" autocomplete="off" class="telNumber" v-model.trim="telNumber"
                    :class="{ 'error_input': errPop1 }" placeholder="请输入手机号" @focus="userFocus" @blur="userBlur"
                    @input="userInput" />
                </el-form>

              </div>
              <div v-if="errPop1" class="err_mess">
                <p id="errMessP" v-text="errPop1"></p>
              </div>
              <div class="pass_inp">
                <el-input v-if="tabActive == 2" type="text" name="x_code1" style="
                    position: absolute;
                    font-size: 0;
                    width: 1px;
                    height: 1px;
                    padding: 0;
                    border-bottom: 0 !important;
                  " />
                <p v-if="tabActive == 2" class="getCode cursor_p" :class="{ 'disabled_code': showDisabled }"
                  :id="getCodeAfter ? 'getcodeAfter' : null" @click="getCode()" v-text="getCodeAfter
                    ? '已发送(' + codeAfterNum + 's)'
                    : '获取验证码'
                    "></p>
                <!-- 密码输入框 -->
                <el-input v-if="tabActive == 0" name="pass" :type="passType" maxlength="50" id="passWord" ref="passTagInput"
                  placeholder="请输入密码" :class="{ 'error_input': errPop2 }" v-model.trim="passWord" @keyup.enter.native="subMit()" @focus="passFocus"
                  @blur="passBlur" />
                <!-- 验证码输入框 -->
                <el-input v-else name="x_code" type="text" maxlength="50" id="verCode" placeholder="请输入验证码"
                  :class="{ 'error_input': errPop2 }" v-model.trim="verCode" @focus="codeFocus" @blur="codeBlur" />
                <span class="cursor_p" v-if="tabActive == 0" @click="hidePass()">
                  <img v-if="passShowHide" style="width: 16px; height: 16px" src="../images/login/hidepass.png" alt />
                  <img v-else style="width: 16px; height: 16px" src="../images/login/showpass.png" alt />
                </span>
              </div>
              <div v-if="errPop2" class="err_mess">
                <p id="errMessP" v-text="errPop2"></p>
              </div>
              <div class="code_inp" v-if="showErrCode">
                <!-- 三次密码错误 -->
                <img id="codePic" :src="codeImgSrc" alt title="点击刷新" @click="getCaptcha()" />
                <!-- <span class="code_btn" title="获取验证码"  @click="getCodeErr()">获取验证码</span> -->
                <input name="x_code" type="text" maxlength="4" id="errverCode" placeholder="请输入验证码"
                  autocomplete="new-password" v-model.trim="errverCode" @focus="codeFocus" @blur="codeBlur" />
                <div v-if="showError" class="err_mess">
                  <p id="errMessP" v-text="errPop2"></p>
                </div>
              </div>
            </div>
            <div v-if="showErrCode" class="login_btn">
              <!--  style="margin-top: 50px;" -->
              <button class="cursor_p" @click="subMit()">登录</button>
            </div>
            <div v-else class="login_btn">
              <!--  style="margin-top: 50px;" -->
              <!-- <button ref="saveBtn" class="cursor_p" @click="subMit()"
                :class="{ 'disabled_cursor': ((!userName || !passWord) && tabActive == 0) || ((!telNumber || !verCode) && tabActive == 2) }">登录</button> -->
              <button ref="saveBtn" class="cursor_p" @click="subMit()">登录</button>
            </div>
            <!-- <div v-if="tabActive == 0 || tabActive == 2" class="operation_account">
              <div class="register_box">
                <span class="guide_language">还没有账号？</span>
                <span class="register_button" @click="nextPage = 3">立即注册</span>
              </div>
              <span class="forget_pass cursor_p" @click="forgetPass()">忘记密码？</span>
            </div> -->
          </div>
        </div>
        <p class="fif_notice">
          登录即代表同意
          <a class="privacy_policy" target="_blank" onmouseover="this.style.cursor='hand'"
            href="https://www.fifedu.com/interface/html/H5-Agreement.html">《讯飞高教隐私权政策》</a>
        </p>
      </div>
      <!-- 账号登录-绑定页面 -->
      <div id="loginbind" v-if="nextPage == 2" :class="schoolShowFlag ? 'login_popup login_popup_c' : 'login_popup'">
        <div class="id_box">
          <div class="id_head">
            <div class="id_user_name">
              <h3>张丽娜</h3>
            </div>
            <p>清华大学</p>
            <div class="tied_id_mark id_mark">学生</div>
          </div>
          <div v-if="idTiednumSuc" class="login_success">
            <img src="../../src/images/login/success.svg" alt />
            <div class="suc_mess">登录成功</div>
          </div>
          <div v-else class="id_tiednum">
            <div class="id_tied_phone">
              <div class="tied_tit">
                <p>绑定手机号</p>
              </div>
              <div class="tied_inp">
                <div class="phone_number">
                  <input type="text" class="login_inp" name="phone_num" placeholder="请输入手机号" />
                </div>
                <div class="ver_code">
                  <p class="get_code" @click="getCode()">获取验证码</p>
                  <input type="text" class="login_inp" name="v_code" placeholder="输入验证码" />
                </div>
              </div>
              <div class="tied_btn login_btn">
                <button>绑定</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 注册页面 -->
      <RegisterAnAccount v-show="nextPage == 3" @backspace="backspace"></RegisterAnAccount>
    </div>
    <!-- /*  忘记密码框 */ -->
    <forgetView v-else-if="showForget && !loginSuc" :showForget="showForget" :roleEnName="roleEnName" :oldPass="passWord"
      :userName="userName" @offForget="changeShowForget($event)"></forgetView>
    <!-- /* 学工号登陆 */ -->
    <elseView v-if="elseLoginWay" @offSchoolList="changeElse($event)"></elseView>
    <!-- /* 二维码登录 */ -->
    <qrView v-if="qrLoginWay" @offQRlogin="changeQrway($event)"></qrView>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <p style="margin-top: 0">
          为保障您的数据安全，请按照密码规则修改弱密码
        </p>
        <el-form-item label="用户名">
          <el-input v-model="userName" readonly></el-input>
        </el-form-item>
        <el-form-item label="原始密码" prop="pwd">
          <el-input type="password" v-model="ruleForm.pwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pwdNew">
          <el-input type="password" v-model="ruleForm.pwdNew" placeholder="长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="pwdNew1">
          <el-input type="password" v-model="ruleForm.pwdNew1" placeholder="长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 进行弱密码的提示 -->
    <WeakPassword :show="showWeakPassword" :roleEnName="roleEnName" @clonseWeakPassword="clonseWeakPassword"
      @operateChangePassword="operateChangePassword"></WeakPassword>
  </div>
</template>

<script>
import axios from "axios";
import CryptoJS from "crypto-js";
import $ from "jquery";
import { EduSSO } from "../../static/utils/sso.js";
/* 组件引入 */
import forgetView from "../components/forgetView.vue";
import elseView from "../components/elseView.vue";
import qrView from "../components/QRView.vue";
import dragView from "../components/logindDrag";
import RegisterAnAccount from "../components/RegisterAnAccount.vue";
import WeakPassword from "../components/WeakPassword.vue";

import {
  checkUserName,
  verifiCation,
  getValidateCode,
  checkValidateCode,
  updatePwdNew,
  addSkipUpdatePwdCount
} from "../request/api-ysx";

// const stream = weex.requireModule('stream');
export default {
  name: 'home',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (value !== "") {
          if (
            !/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,20}$))/.test(
              value
            )
          )
            callback(
              new Error(
                "长度需8-20位，数字、小写字母、大写字母、特殊字符，至少包含三种"
              )
            );
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.pwdNew) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      throttle:false,
      roleEnName: '',//弱密码账号的校色
      showWeakPassword: false,//弱密码提示
      initialization:false,
      origin: location.origin,
      showDisabled: true,
      showSearBtn: true,
      showTeacherBackground: '',
      codeImgSrc: "",
      loginTab: [],
      tabActive: 0, // 登陆方式切换+控制指定功能显示隐藏
      inputData: {
        telNumber: ''
      },
      userName: "", // v-m 账号
      passWord: "", // v-m 密码
      telNumber: "", // v-m 手机号
      errverCode: "", // 输错三次密码
      showErrCode: false, // 显示对应验证码框
      showImgErrCode: false, // 显示对应拖拽图片验证码框
      codeImg: "", // 验证码图片
      verCode: "", // v-m 验证码
      uuid: "", // v-m 验证码 暂存
      showError: false, // 验证码错误
      passType: "password",
      passShowHide: false,

      showErr: false, // 错误信息显示
      errPop: "", // 错误信息
      errPop1: "", // 错误信息1
      errPop2: "", // 错误信息2
      nextPage: 1, // 账号——身份绑定页面
      tiedSuc: false, // 身份手机号绑定成功
      idTiednumSuc: false, // 绑定后登陆成功

      showNotied: false, // 手机——显示未绑定提示信息
      showForget: false, // 显示忘记密码页面
      getCodeAfter: false, // 显示验证码倒计时
      codeAfterNum: 60, // 验证码数字倒计时
      ifNotied: false, // 判断是否绑定-弹框
      ifNotiedText: "",
      // codeSucced: false, // 账号验证码成功

      // QrUrl: '',      // 微信/钉钉二维码登录地址
      QrType: "", // 微信/钉钉二维码标识

      elseLoginWay: false, // 学工号登陆

      qrLoginWay: false, // 二维码登录

      loginSuc: false, // 登陆成功页面
      sucTo: 1, // 跳转成功 倒计时
      isOnline: false, // 是否为线上
      schoolShowFlag: false,
      //强制修改密码
      dialogVisible: false,
      ruleForm: {
        pwd: "",
        pwdNew: "",
        pwdNew1: "",
      },
      rules: {
        pwd: [{ required: true, message: "请输入原始密码", trigger: "blur" }],
        pwdNew: [{ required: true, validator: validatePass, trigger: "blur" }],
        pwdNew1: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  components: {
    forgetView,
    elseView,
    qrView,
    dragView,
    RegisterAnAccount,
    WeakPassword
  },
  created() {
    // 绑定回车事件
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.subMit();
      }
    };
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == "schoolCode") {
        this.schoolShowFlag = true;
      }
    }
  },
  methods: {
    // 登录
    myLogin() {
      const that = this
      // 登录
      var loginurl = this.getIplatPath() + "/ssoservice";
      var edusso = new EduSSO(loginurl, this.getIplatCasPath());
      // 先退出登录
      edusso.casLogout(function (result) { });
      edusso.login(
        "iflyportal",
        "iflyportal",
        "login_name",
        this.userName,
        this.passWord,
        this.uuid,
        function (result) {
          console.log(result);
          if (result && result.result != "success") {
            that.showErr = true;
            that.errPop2 = result.data;
            if (
              result.data == "请输入验证码" ||
              result.data == "验证码错误"
            ) {
              that.showErrCode = true;
              that.getCaptcha();
              that.errPop2 = result.data;
            }
          } else {
            // 成功跳转
            that.loginSuc = true;
            var loginSucTo = setInterval(() => {
              that.sucTo -= 1;
              if (that.sucTo == 0) {
                clearInterval(loginSucTo);
                window.location.href = that.getIplatPath() + "/ssoservice";
              }
            }, 1000);
          }
        }
      );
    },
    // 关闭弱密码提示弹窗
    clonseWeakPassword() {
      this.showWeakPassword = false;
      // 调用记录接口
      this.addPwdCount();
    },
    // 操作弱密码提示弹窗
    operateChangePassword(type) {
      if (type == '1') { // 进入修改密码模式
        this.forgetPass('WeakPassword');
        this.showWeakPassword = false;
        this.dialogVisible = false;
      } else if (type == '2') {  //稍后修改
        this.showWeakPassword = false;
        this.dialogVisible = false;
        // 调用记录接口
        this.addPwdCount()
      }
    },

    // 记录修改弱密码提示次数
    addPwdCount() {
      var Base64 = require("js-base64").Base64;
      const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
      const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
      const srcs = CryptoJS.enc.Utf8.parse(this.passWord);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      let params = {
        username: this.userName,
        password: Base64.encode(encrypted),
      }
      addSkipUpdatePwdCount({ ...params }).then((res) => {
        console.log(res, '记录次数');
        // 重新进行登录
        this.myLogin();
      });
    },
    changePwd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var Base64 = require("js-base64").Base64;
          const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
          const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
          const srcs1 = CryptoJS.enc.Utf8.parse(this.ruleForm.pwd);
          let encrypted1 = CryptoJS.AES.encrypt(srcs1, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          });
          const srcs2 = CryptoJS.enc.Utf8.parse(this.ruleForm.pwdNew);
          let encrypted2 = CryptoJS.AES.encrypt(srcs2, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          });
          let params = {
            loginName: this.userName,
            pwd: Base64.encode(encrypted1),
            newPwd: Base64.encode(encrypted2),
          };
          updatePwdNew({ ...params }).then((res) => {
            if (res.status != "SUCCESS") return this.$message.error(res.message);
            this.$message({ message: res.message, type: "success" });
            this.dialogVisible = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCaptcha() {
      $.ajax({
        url:
          `${window.globalParameter.VUE_APP_CYCORE}/fif_captcha` +
          "/getCaptcha?t_=" +
          Date.parse(new Date()),
        success: (data) => {
          this.codeImgSrc = JSON.parse(data).data.image;
          this.uuid = JSON.parse(data).data.uuid;
        },
      });
    },
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      this.isOnline = localhostPath.indexOf("hecs.fifedu.com/iplat/");
      return localhostPath;
    },
    //获取iplat路径
    getIplatPath() {
      // var iplatPath = location.origin + '/iplat/';
      var iplatPath = 'https://ilearn.jlu.edu.cn/iplat/';
      console.log(iplatPath, '地址');
      return iplatPath;
    },
    //获取iplat路径 线上下
    getIplatCasPath() {
      // 线上
      var login = `${window.globalParameter.VUE_APP_CYCORE}/cas-server`;
      return login;
    },
    tabLogin(ind) {
      this.tabActive = ind;
      this.telNumber = "";
      this.userName = "";
      this.passWord = "";
      this.errverCode = "";
      this.showErr = false;
      this.errPop1 = ''
      this.errPop2 = ''
    },
    hidePass() {
      if (this.passType == "password") {
        this.passType = "text";
        this.passShowHide = true;
      } else {
        this.passType = "password";
        this.passShowHide = false;
      }
    },
    forgetPass(type) {
      // 打开忘记密码框
      if (type == 'WeakPassword') {
        this.showForget = '2';
      } else {
        this.showForget = true;
      }
    },
    changeShowForget(data, type) {
      // 关闭 忘记密码
      this.showForget = data;
      if (type == 'weakPassword') {
        this.showWeakPassword = true
      }
    },
    changeElse(data) {
      this.elseLoginWay = data;
    },
    /* 获取验证码 */
    getCode() {
      console.log("<<<<<<<<<<<<<<<<<<<<<<");
      // this.showErr = false;
      const that = this;
      var canToget = false;
      if (this.telNumber == "") {
        this.errPop1 = "请输入手机号";
        this.showErr = true;
        canToget = true;
        return false;
      } else if (!/^1\d{10}$/i.test(this.telNumber)) {
        this.errPop1 = "请输入正确的手机号";
        canToget = true;
        return false;
      } else {
        canToget = true;
      }
      if (this.codeAfterNum == 60) {
        this.showImgErrCode = true;
      }
    },
    getCodeFunc(token,x,y) {
      //获取验证码-图形拖拽后调用发送验证码
      getValidateCode({ mobile: this.telNumber,uuid:token,X:x,Y:y })
        .then((res) => {
          if (res.status == 1) {
            // that.codeSucced = true;
            this.getCodeAfter = true;
            this.showImgErrCode = false;
            var serCodeAfter = setInterval(() => {
              this.codeAfterNum -= 1;
              if (this.codeAfterNum == 0) {
                clearInterval(serCodeAfter);
                this.getCodeAfter = false;
                this.codeAfterNum = 60;
              }
            }, 1000);
          } else {
            if (res.status == 0) {
              this.ifNotied = true;
              this.ifNotiedText = res.msg;
              this.showImgErrCode = false;
              var setTifNo = setTimeout(() => {
                this.ifNotied = false;
                clearTimeout(setTifNo);
              }, 3000);
            }
            // clearInterval(serCodeAfter);
            // this.getCodeAfter = false;
            // this.codeAfterNum = 60;
          }
        }).catch((err) => {
          this.ifNotied = true;
          this.ifNotiedText =
            "该手机号未绑定账号，请使用账号登录后在设置中绑定手机号";
          var setTifNo = setTimeout(() => {
            this.ifNotied = false;
            clearTimeout(setTifNo);
          }, 3000);
          console.log(err);
        });
    },
    /* 账号密码 focus blur 事件 */
    userFocus() {
      this.showSearBtn = true
      // $(".user_inp input").css({ "border-bottom": "#3388FF solid 1px" });
    },
    userInput() {
      if (!/^1\d{10}$/i.test(this.telNumber)) {
        this.showDisabled = true
      } else {
        this.showDisabled = false
      }
    },
    userBlur() {
      this.showSearBtn = false
      // $(".user_inp input").css({ "border-bottom": "#e5e5e5 solid 1px" });
      if (this.tabActive == 2) {
        if (
          !/^1\d{10}$/i.test(this.telNumber) &&
          this.telNumber != ""
        ) {
          this.showErr = true;
          this.errPop1 = "请输入正确的手机号";
          // $(".user_inp input").css({ "border-bottom": "#3388FF solid 1px" });
          return false;
        } else {
          // $(".user_inp input").css({ "border-bottom": "#e5e5e5 solid 1px" });
          this.showErr = false;
          this.errPop1 = "";
        }
      }
    },
    passFocus() {
      // $(".pass_inp input").css({ "border-bottom": "#3388FF solid 1px" });
    },
    passBlur() {
      // $(".pass_inp input").css({ "border-bottom": "#e5e5e5 solid 1px" });
    },
    codeFocus() {
      // $("#verCode").css({ "border-bottom": "#3388FF solid 1px" });
    },
    codeBlur() {
      // $("#verCode").css({ "border-bottom": "#e5e5e5 solid 1px" });
    },
    backspace() {
      this.nextPage = 1
    },
    /* 账号密码 focus blur 事件 */
    // 点击登录
    subMit() {
      console.log(this.passWord);
      // if(this.throttle) return // 节流
      this.throttle = true; // 节流
      sessionStorage.removeItem('backUrl') // 清除返回地址
      const that = this;
      var Tuser = "";
      var Tpass = "";
      var Tcode = "";
      if (this.tabActive == 0) {
        this.loginFunc();
      } else if (this.tabActive == 2) {
        if (this.telNumber == "") {
          this.errPop1 = "请输入手机号";
          this.showErr = true;
          // $(".telNumber").css({ "border-bottom": "#3388FF solid 1px" });
          return false;
        } else if (this.verCode == "") {
          this.errPop2 = "请输入验证码";
          this.showErr = true;
          // $("#verCode").css({ "border-bottom": "#3388FF solid 1px" });
          return false;
        } else if (this.telNumber != "" && this.verCode != "") {
          checkValidateCode({
            mobile: this.telNumber,
            code: this.verCode,
          }).then((res) => {
            if (res.status == 1) {
              Tuser = res.data.username;
              Tpass = res.data.password;
              // 登录
              var loginurl = that.getIplatPath() + "/ssoservice";
              var edusso = new EduSSO(loginurl, that.getIplatCasPath());
              // 先退出登录
              edusso.casLogout(function (result) { });
              edusso.login(
                "iflyportal",
                "iflyportal",
                "login_name",
                Tuser,
                Tpass,
                Tcode,
                function (result) {
                  if (result && result.result != "success") {
                    that.showErr = true;
                    that.errPop2 = result.msg;
                    return;
                  } else {
                    // 成功跳转
                    that.loginSuc = true;
                    that.pass()
                    var loginSucTo = setInterval(() => {
                      that.sucTo -= 1;
                      if (that.sucTo == 0) {
                        clearInterval(loginSucTo);
                        window.location.href =
                          that.getIplatPath() + "/ssoservice";
                      }
                    }, 1000);
                  }
                }
              );
            } else if (res.status == -1) {
              window.location.href = window.globalParameter.VUE_APP_PASS + "/iplat-pass/mobile/toBind?info=" + res.data;
              return;
            } else {
              // this.showErr = true;
              this.errPop2 = res.msg;
              // this.$message.error(res.msg)
              return;
            }
          });
        } else if (this.telNumber == "") {
          $(".user_inp input").focus();
        } else if (this.verCode == "") {
          $(".pass_inp input").focus();
        }
      }
    },
    pass() {
      let orginUrl = location.origin
      var url = orginUrl.indexOf('www.') != -1 ? "https://cycore.fifedu.com/cas-server/login?service=" + location.origin + "/iplatform-zjzx/common/sso/login" : "https://hecs.fifedu.com/cas-server/login?service=" + location.origin + "/iplatform-zjzx/common/sso/login"
      //    if(orginUrl.indexOf('www.') != -1 || orginUrl.indexOf('www.') != -1){
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          console.log(xhr.responseText);
        }
      };
      xhr.send();
      //    }
    },
    loginFunc() {
      let Base64 = require("js-base64").Base64;
      const that = this;
      if (window.sessionStorage && this.userName != "" && this.passWord != "") {
        sessionStorage.setItem("user", this.userName);
        sessionStorage.setItem(
          this.userName.toLowerCase(),
          Base64.encode(this.passWord)
        ); // 设置值
      }
      if (this.userName == null || this.userName == "") {
        $(".user_inp input").focus();
        return false;
      } else if (this.passWord == null || this.passWord == "") {
        $(".pass_inp input").focus();
        return false;
      }
      // 判断验证码
      if ($("#errverCode").is(":visible")) {
        var captcha = document.getElementById("errverCode").value;
        if (captcha == null || captcha == "") {
          that.errPop2 = "请输入验证码";
          $("#errverCode").focus();
          return false;
        }
        $.ajax({
          url: `${window.globalParameter.VUE_APP_CYCORE}/fif_captcha` + "/checkCaptcha?uuid=" + this.uuid + "&captcha=" + captcha,
          success: (data) => {
            if (JSON.parse(data).data.check != "successed") {
              //验证码输入错误
              that.errPop2 = JSON.parse(data).data.msg;
              $("#errverCode").focus();
              that.getCaptcha(); //获取验证码
              return false;
            } else {
              this.checkPass();
            }
          },
        });
      } else {
        this.checkPass();
      }
    },
    checkPass() {
      const that = this;
      let isCheck = true;
      // 判断该用户是否禁用
      // checkUserName({ username: this.userName }).then((res) => {
      //   if (res.status != "SUCCESS") {
      //     this.errPop2 = res.message;
      //     isCheck = false;
      //     this.throttle = false; // 节流
      //     return false;
      //   }
      // });
      if (isCheck) {
        let Base64 = require("js-base64").Base64;
        const key = CryptoJS.enc.Utf8.parse("dufy20170329java"); //16位
        const iv = CryptoJS.enc.Utf8.parse("dufy20170329java");
        const srcs = CryptoJS.enc.Utf8.parse(this.passWord);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        // verifiCation({
        //   username: this.userName,
        //   password: Base64.encode(encrypted),
        // }).then((res) => {
        //   if (res.status != "SUCCESS") {
        //     if (res.data === 3) {
        //       //强制修改密码
        //       this.dialogVisible = true;
        //       this.ruleForm = {
        //         pwd: "",
        //         pwdNew: "",
        //         pwdNew1: "",
        //       };
        //       this.throttle = false; // 节流
        //       return;
        //     } else if (res.status == 'PASSWORDERROR') {
        //       that.roleEnName = res.data.roleEnName;
        //       that.showWeakPassword = true;
        //       this.throttle = false; // 节流
        //       return
        //     }
        //   }
          // 登录
          var loginurl = that.getIplatPath() + "/ssoservice";
          var edusso = new EduSSO(loginurl, that.getIplatCasPath());
          // 先退出登录
          edusso.casLogout(function (result) { });
          edusso.login(
            "iflyportal",
            "iflyportal",
            "login_name",
            that.userName,
            that.passWord,
            that.uuid,
            function (result) {
              console.log(result);
              if (result && result.result != "success") {
                that.showErr = true;
                that.errPop2 = result.data;
                that.throttle = false; // 节流
                if (
                  result.data == "请输入验证码" ||
                  result.data == "验证码错误"
                ) {
                  that.showErrCode = true;
                  that.getCaptcha();
                  that.errPop2 = result.data;
                }
              } else {
                // 成功跳转 
                that.loginSuc = true;
                var loginSucTo = setInterval(() => {
                  that.sucTo -= 1;
                  if (that.sucTo == 0) {
                    clearInterval(loginSucTo);
                    window.location.href = that.getRequest().service?that.getIplatPath() + `/ssoservice?service=${that.getServicePrams()}`:that.getIplatPath() + "/ssoservice";
                  }
                }, 1000);
              }
            }
          );
        //  });
      }
    },
    // 获得当前路径的参数
    getRequest(_url) {
      var url = _url ? String(_url) : String(document.location); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        if (str.indexOf("#") != -1) {
          str = str.substr(0, str.indexOf("#"))
        }
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          var indexOfadd = strs[i].indexOf("=");
          if (indexOfadd > 0) {
            var key = strs[i].substr(0, indexOfadd);
            var value = strs[i].substr(indexOfadd + 1);
            theRequest[key] = ((key in theRequest) ? (theRequest[key] + ",") : "") + value;
          }
        }
      }
      return theRequest;
    },
    // 获得service参数
    getServicePrams(){
       var url = location.href;
       var params = ''
       if(url.indexOf('?service') !=1){
            params = url.split('?service=')[1]
       }
       return params
    },
    offDarg(token,x,y) {
      if (token == false) {
        this.showImgErrCode = v;
      } else if (this.tabActive == 2) {
        this.getCodeFunc(token,x,y);
      } else {
        this.uuid = v;
        this.checkPass();
      }
    },
    /* 微信扫码登陆 */
    openQrLogin(key) {
      const that = this;
      if (key == "wechat") {
        // 微信登录
        that.QrType = "wechat";
        axios
          .get("https://pass.fifedu.com/iplat-pass/web/getWebLoginUrl?type=2")
          .then(function (res) {
            // window.open(res.data.data.dingTalkUrl, "_blank", "scrollbars=no,height=470, width=620,resizable=1,modal=false,alwaysRaised=yes");
            window.open(res.data.data.weixinUrl, "_blank");
          })
          .catch(function (err) {
            console.log(err);
          });
      } else if (key == "ding") {
        // 钉钉登陆
        that.QrType = "ding";
        axios
          .get("https://pass.fifedu.com/iplat-pass/web/getWebLoginUrl?type=2")
          .then(function (res) {
            // window.open(res.data.data.dingTalkUrl, "_blank", "scrollbars=no,height=470, width=620,resizable=1,modal=false,alwaysRaised=yes");
            window.open(res.data.data.dingTalkUrl, "_blank");
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    /* 打开学工号登陆页面 */
    openElse() {
      this.loginSuc = false; // 隐藏登陆成功页面
      this.showForget = false; // 隐藏忘记密码页面
      this.elseLoginWay = true; // 显示学工号登陆页面
    },
    /* 二维码登录 */
    QRloginFunc() {
      this.qrLoginWay = true;
    },
    /* 二维码 跳 账号登录 */
    changeQrway(data) {
      this.qrLoginWay = data;
    },
  },
  mounted() {
    let url = location.href
    if (url.indexOf('shortName=zyzlxs') != -1) { this.showTeacherBackground = 1 }
    if (url.indexOf('shortName=zyzljs') != -1) { this.showTeacherBackground = 2 }
    if (location.href.indexOf('showWay=1') != -1) {
      this.nextPage = 3
    }
    this.$nextTick(() => {
      setTimeout(() => {
      //  this.userName = this.$refs.saveTagInput.$el.getElementsByTagName('input').value
      //  this.passWord = this.$refs.saveTagInput.$el.getElementsByTagName('input').value
      // this.userName = ''
        this.initialization = false
      }, 1000);
    })
  },
};
</script>
<style>
@import url("../style/login");

input::-ms-clear {
  display: none;
}

input::-ms-reveal {
  display: none;
}

.err_mess {
  position: relative;
  min-height: 14px;
  width: 240px;
}

.err_mess p {
  font-size: 12px;
  line-height: 14px;
  color: #ff553a;
  letter-spacing: 0;
}

.code_inp {
  position: relative;
}

#codePic {
  position: absolute;
  top: 0px;
  right: 0;
  /* margin-top: 5px;
  margin-left: 30px; */
  width: 100px;
  height: 40px;
  background-color: #f4f4f4;
}

.code_btn {
  position: absolute;
  top: 12px;
  right: 25px;
  font-size: 12px;
  color: #3388ff;
  cursor: pointer;
}

.el-form-item {
  margin-bottom: 12px;
}

.el-input__inner {
  color: #12151A !important;
}

.el-input .el-input__inner::placeholder {
  color: #C2C7CC !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/loginView.vue